/** @format */

import React, { useRef, useState, useEffect, Fragment } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import "../App.css";

import { BrowserRouter as Router, Link, Route } from "react-router-dom";
import { SetEmpPos } from "./setApprovers";
import { set } from "date-fns";
// import { PassModal } from "./commentModal";
import { PassModal } from "./passwordChangeModal";
import { EmployeeAdd } from "./add_employee";
// import { PasswordChangeModal } from "./passwordChangeModal";

export const EmpPrivConfig = ({ setAuth }) => {
  const selectRef = useRef();

  const [name, setName] = useState("");
  const [empSelected, setEmpSelected] = useState(false);

  const [empLvl, setEmpLvl] = useState(null);
  const [empApp1, setEmpApp1] = useState(null);
  const [empApp2, setEmpApp2] = useState(null);
  const [empApp3, setEmpApp3] = useState(null);
  const [empApp4, setEmpApp4] = useState(null);
  const [empApp5, setEmpApp5] = useState(null);
  const [empApp6, setEmpApp6] = useState(null);
  const [empApp7, setEmpApp7] = useState(null);
  const [empApp8, setEmpApp8] = useState(null);
  const [empPos, setEmpPos] = useState(null);
  const [empTask, setEmpTask] = useState(null);
  const [empDep, setEmpDep] = useState(null);

  const [isAdmin, setIsAdmin] = useState(null);
  const [isTrainReqManager, setIsTrainReqManager] = useState(false);
  const [currentEmp, setCurrentEmp] = useState(null);

  const [isApp1, setIsApp1] = useState(null);
  const [isApp2, setIsApp2] = useState(null);
  const [isApp3, setIsApp3] = useState(null);
  const [isApp4, setIsApp4] = useState(null);
  const [isApp5, setIsApp5] = useState(null);
  const [isApp6, setIsApp6] = useState(null);
  const [isApp7, setIsApp7] = useState(null);
  const [isApp8, setIsApp8] = useState(null);

  const [privData, setPrivData] = useState({
    isAdminSend: null,
    isTrainReqManagerSend: null,
    currentEmpSend: null,
    isAppSend1: null,
    isAppSend2: null,
    isAppSend3: null,
    isAppSend4: null,
    isAppSend5: null,
    isAppSend6: null,
    isAppSend7: null,
    isAppSend8: null,
    empPosSend: null,
    empStrSend: null,
    empTaskSend: null,

    // ...
  });

  const [passChangeConfirmed, setPassChangeConfirmed] = useState(false);

  const handlePassChangeConfirmation = (newValue) => {
    setPassChangeConfirmed(newValue);
  };

  async function getName() {
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dashboard`,
        {
          method: "GET",
          headers: { token: localStorage.token },
        }
      );
      const parsRes = await resp.json();
      // console.log(parsRes);

      setName(parsRes.emp_name);
    } catch (err) {
      console.error(err.message);
    }
  }

  // get employees list
  const [emps, setEmps] = useState([]);
  const fetchEmp = async () => {
    // Fetch the forms and their IDs from the database.
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/employees`
    );
    const data = await response.json();
    setEmps(data.sort((a, b) => a.emp_name.localeCompare(b.emp_name)));
    if (response.ok) {
    }

    // console.log(data[1].emp_role);
  };

  const setPrivilege = async () => {
    // set privilege
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/privilegeSet`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: localStorage.token,
        },
        body: JSON.stringify(privData),
      }
    );
    if (response.ok) {
      accept();
    }
  };

  const [positions, setPositions] = useState([]);
  const [tasks, setTasks] = useState([]);

  async function getPositions() {
    try {
      const getPos = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getPositions`
      );
      const parsRes = await getPos.json();
      setPositions(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  async function getTasks() {
    try {
      const getTask = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/getTasks`
      );
      const parsRes = await getTask.json();
      setTasks(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const [structures, setStructures] = useState([]);

  async function getStructures() {
    try {
      const getStr = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/structures`
      );
      const parsRes = await getStr.json();
      setStructures(parsRes);
    } catch (err) {
      console.error(err.message);
    }
  }

  const displayEmpPos = (posId) => {
    let posToDisplay = "";
    for (let i = 0; i < positions.length; i++) {
      if (positions[i].role_id == posId) {
        posToDisplay = positions[i].role_name;
      }
    }
    return posToDisplay;
  };

  const displayEmpTask = (taskId) => {
    let taskToDisplay = "";
    for (let i = 0; i < tasks.length; i++) {
      if (tasks[i].task_id == taskId) {
        taskToDisplay = tasks[i].task_name;
      }
    }
    return taskToDisplay;
  };

  const displayEmpStr = (depId) => {
    let depToDisplay = "";
    for (let i = 0; i < structures.length; i++) {
      if (structures[i].str_id == depId) {
        depToDisplay = structures[i].str_name;
      }
    }
    return depToDisplay;
  };

  useEffect(() => {
    setAuth(true);
    fetchEmp();
    getName();
    getPositions();
    getTasks();
    getStructures();
    // fetchDocs();
    // fetchAppro();
  }, []);

  // handle the employee selection
  const handleEmployeeSelection = (e) => {
    setEmpPos(0);
    setEmpTask(0);
    setEmpDep(0);

    for (let i = 0; i < emps.length; i++) {
      if (emps[i].emp_id == e.target.value) {
        setEmpLvl(emps[i].emp_level);
        setIsAdmin(emps[i].emp_level);
        setIsTrainReqManager(emps[i].emp_trainees_manager);
        setCurrentEmp(emps[i].emp_id);

        if (emps[i].emp_role !== null) {
          setEmpPos(emps[i].emp_role);
        } else {
          setEmpPos(0);
        }

        if (emps[i].emp_task !== null) {
          setEmpTask(emps[i].emp_task);
        } else {
          setEmpTask(0);
        }

        if (emps[i].asigned_str !== null) {
          setEmpDep(emps[i].asigned_str);
        } else {
          setEmpDep(0);
        }

        document.getElementById("position-select").value = emps[i].emp_role;
        document.getElementById("task-select").value = emps[i].emp_task;
        document.getElementById("structure-select").value = emps[i].asigned_str;

        setPrivData({
          ...privData,
          isAdminSend: emps[i].emp_level,
          empPosSend: emps[i].emp_role,
          empTaskSend: emps[i].emp_task,
          empStrSend: emps[i].asigned_str,
          isTrainReqManagerSend: emps[i].emp_trainees_manager,
          currentEmpSend: emps[i].emp_id,
        });

        // document.getElementById('position-select').selected = displayEmpPos(emps[i].emp_role);
      }
    }
    setEmpSelected(true);
  };
  // console.group(document.getElementById("department-select").value);
  const dispAdmAstat = () => {
    if (empLvl == 1) {
      document.getElementById("admin-check").checked = true;
      setIsAdmin(1);
    } else {
      document.getElementById("admin-check").checked = false;
      setIsAdmin(0);
    }
  };

  const dispTrainManagerStat = () => {
    if (isTrainReqManager == true) {
      document.getElementById("reqManage-check").checked = true;
      setIsTrainReqManager(true);
    } else {
      document.getElementById("reqManage-check").checked = false;
      setIsTrainReqManager(false);
    }
  };

  useEffect(() => {
    setPrivData({ ...privData, isAdminSend: isAdmin });
  }, [isAdmin]);

  useEffect(() => {
    setPrivData({ ...privData, isTrainReqManagerSend: isTrainReqManager });
  }, [isTrainReqManager]);
  const handleCheckIsAdmin = () => {
    if (document.getElementById("admin-check").checked == true) {
      setIsAdmin(1);
    } else {
      setIsAdmin(0);
    }
  };

  const handleCheckTrainReqManager = () => {
    if (document.getElementById("reqManage-check").checked == true) {
      setIsTrainReqManager(true);
    } else {
      setIsTrainReqManager(false);
    }
  };

  useEffect(() => {
    dispAdmAstat();
    dispTrainManagerStat();
  }, [currentEmp]);

  const handlePrivSubmit = () => {
    setPrivilege();
    // document.getElementById("position-select").disabled = true;
    fetchEmp();
  };

  const handlePosSelect = (e) => {
    e.preventDefault();
    const value = e.target.value === "null" ? null : parseInt(e.target.value, 10);
    setPrivData({ ...privData, empPosSend: value });
  };

  const handleTaskSelect = (e) => {
    e.preventDefault();

    setPrivData({ ...privData, empTaskSend: parseInt(e.target.value) });
  };

  const handleStrSelect = (e) => {
    e.preventDefault();
    const value = e.target.value === "null" ? null : parseInt(e.target.value, 10);
    setPrivData({ ...privData, empStrSend: value });
  };

  // confirmation dialog -------------------------------------------

  const handleAccountDelete = async () => {
    try {
      if (
        currentEmp !== "" ||
        currentEmp !== null ||
        currentEmp !== undefined
      ) {
        const userDelete = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/userDelete/${currentEmp}`,
          {
            method: "DELETE",
            headers: { token: localStorage.token },
          }
        );
        if (userDelete.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "conifrmé",
            detail: "Employé supprimé",
            life: 3000,
          });
          setEmpSelected(false);
          setEmpLvl(0);
          setCurrentEmp("");
          setEmpPos(0);
          setEmpTask(0);
          fetchEmp();
          document.getElementById("default-selection").selected = true;
        }
      }
      // const parsRes = await userDelete.json();
    } catch (err) {
      console.error(err.message);
    }
  };

  const toast = useRef(null);

  const accept = () => {
    toast.current.show({
      severity: "info",
      summary: "conifrmé",
      detail: "Changement effectué",
      life: 3000,
    });
  };

  const accept2 = () => {
    toast.current.show({
      severity: "success",
      summary: "conifrmé",
      detail: "Mot de passe Modifié",
      life: 5000,
    });
  };

  const accept3 = () => {
    toast.current.show({
      severity: "success",
      summary: "conifrmé",
      detail: "Employé ajouté",
      life: 3000,
    });
  };

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "Annulée",
      detail: "demande annulée",
      life: 3000,
    });
  };

  const reject2 = () => {
    toast.current.show({
      severity: "warn",
      summary: "Non-authorisé",
      detail: "L'utilisateur est déjà dans la base de données.",
      life: 3000,
    });
  };

  const confirm1 = (e) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer les modifications?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handlePrivSubmit(),
      reject,
      className: "my-custom-confirm-dialog",
    });
  };

  const confirm2 = (e) => {
    e.preventDefault();
    confirmDialog({
      message: "Confirmer la suppression du compte?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Oui",
      rejectLabel: "Non",
      accept: () => handleAccountDelete(),
      reject,
      className: "my-custom-confirm-dialog",
    });
  };

  useEffect(() => {
    if (passChangeConfirmed == true) {
      accept2();
    }
  }, [passChangeConfirmed]);

  // ------------------------------------------------------------
  const [empAdded, setEmpAdded] = useState(false);
  const [empExist, setEmpExist] = useState(false);
  const empExists = (resVal) => {
    setEmpExist(resVal);
  };
  const empIsAdded = (sentVal) => {
    setEmpAdded(sentVal);
  };

  useEffect(() => {
    if (empAdded === true) {
      fetchEmp();
      accept3();
    }
  }, [empAdded]);

  useEffect(() => {
    if (empExist === true) {

      reject2();
    }
  }, [empExist]);



  useEffect(() => {
    if (empSelected === true) {
      document.getElementById("btn-delete-user").disabled = false;

      document.getElementById("btn-submit-form").disabled = false;
      document.getElementById("btn-submit-form").className =
        "bg-blue-500 hover:bg-blue-700  text-white font-bold py-2 px-4 rounded";
    } else {
      document.getElementById("btn-submit-form").disabled = true;
      document.getElementById("btn-delete-user").disabled = true;
    }
  }, [empSelected]);
  return (
    <Fragment>
      <div className="employees-settings flex-auto flex flex-col md:flex-row justify-around">
        <div className="admin-form">
          <h5>Gestion des privilèges des employés</h5>

          <form>
            <div className="employee-selection">
              <label className="label-control" for="employee">
                Sélectionner l'employé:
              </label>
              <select
                id="employee"
                className="employee-select form-control"
                onChange={handleEmployeeSelection}
              >
                <option id="default-selection" disabled selected value>
                  {" "}
                  -- selectionnez --{" "}
                </option>
                {emps.map((emp) => (
                  <option key={emp.emp_id} value={emp.emp_id}>
                    {emp.emp_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="privileges rounded-md p-3 bg-gray-100">
              <h5>privilèges</h5>

              <div className="form-control">
                <label className="label-control" for="admin">
                  Est Admin:
                </label>
                <input
                  className=""
                  type="checkbox"
                  id="admin-check"
                  name="admin"
                  onChange={() => {
                    handleCheckIsAdmin();
                  }}
                />
              </div>

              <div className="form-control">
                <label className="label-control" for="demande_stage">
                  Gerer les demandes de stage:
                </label>
                <input
                  className=""
                  type="checkbox"
                  id="reqManage-check"
                  name="demande_stage"
                  onChange={() => {
                    handleCheckTrainReqManager();
                  }}
                />
              </div>

              {/* set positions for each employee */}
              <div className="emp-position-set">
                <label className="position-select" for="position-select">
                  Position hiérarchique:
                </label>
                <select
                  ref={selectRef}
                  id="position-select"
                  className="position-select form-control"
                  onChange={handlePosSelect}
                >
                  <option id="default-option" disabled selected value={empPos}>
                    {displayEmpPos(empPos)}
                  </option>
                  <option id="empty-option" value="null">
                    Aucune
                  </option>
                  {positions.map((position) => (
                    <option key={position.role_id} value={position.role_id}>
                      {position.role_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="emp-position-set">
                <label className="position-select" for="task-select">
                  Grade:
                </label>
                <select
                  ref={selectRef}
                  id="task-select"
                  className="position-select form-control"
                  onChange={handleTaskSelect}
                >
                  <option id="default-option" disabled selected value={empTask}>
                    {displayEmpTask(empTask)}
                  </option>
                  {tasks.map((task) => (
                    <option key={task.task_id} value={task.task_id}>
                      {task.task_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="emp-department-set">
                <label className="department-select" for="structure-select">
                  Structure:
                </label>
                <select
                  ref={selectRef}
                  id="structure-select"
                  className="structure-select form-control"
                  onChange={handleStrSelect}
                >
                  <option id="default-option" disabled selected value={empDep}>
                    {displayEmpStr(empDep)}
                  </option>
                  <option id="empty-option" value="null">
                    Aucune
                  </option>

                  {structures.map((structure) => (
                    <option key={structure.str_id} value={structure.str_id}>
                      {structure.str_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="actions">
              {/* <button
              onClick={(e) => {
                handlePrivSubmit(e);
              }}
              className="btn btn-primary"
              type="submit"
            >
              Mettre à jours les privilèges
            </button> */}
              {/* confirmation dialog ----------------------------------------- */}
              <Toast ref={toast} />

              <div className="p-confirm-dialog	">
                <ConfirmDialog className="p-confirm-dialog" />
              </div>

              <Button
                id="btn-submit-form"
                onClick={confirm1}
                icon="pi pi-check"
                label="Mettre à jours les privilèges"
                className="bg-blue-500  text-white font-bold py-2 px-4 rounded"
              ></Button>

              {/* confirmation dialog ----------------------------------------- */}
            </div>
          </form>
          <div className="container bg-gray-100 mx-auto border border-solid pb-3 border-gray-400 rounded  mt-3">
            <label className="department-select" for="structure-select">
              Securité:
            </label>
            <div className="container gap-5 flex flex-col mx-auto border border-solid border-gray-400 rounded-md p-10 flex items-center justify-center">
              {/* <PasswordChangeModal /> */}

              <PassModal
                empSelected={empSelected}
                currentEmp={currentEmp}
                onPassChange={handlePassChangeConfirmation}
              />
              <Button
                id="btn-delete-user"
                onClick={confirm2}
                icon="pi pi-times"
                label="Supprimer le compte!"
                className="bg-orange-500 hover:bg-red-500  text-white font-bold py-2 px-4 rounded"
              ></Button>
            </div>
          </div>
        </div>
        <div className="flex w-auto bg-white rounded-md p-3">
          <EmployeeAdd empIsAdded={empIsAdded} empExists={empExists} />
        </div>
      </div>

      <ToastContainer />
    </Fragment>
  );
};
